<template>
  <div class="table">
    <el-table
      :data="tableData"
      style="width: 100%"
      id="tableCon1"
      border
      height="70vh"
    >
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        label="月份"
        align="center"
        prop="date"
      ></el-table-column>
      <el-table-column
        label="园区"
        align="center"
        prop="place"
      ></el-table-column>
      <el-table-column label="合计任务数" align="center" prop="total">
        <template slot-scope="{ row }">
          <span
            style="color: rgba(25, 144, 255, 1); cursor: pointer"
            @click="handleDetail(row, 1)"
            >{{ row.total }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="已处理" align="center" prop="disposeNum">
        <template slot-scope="{ row }">
          <span
            style="color: rgba(25, 144, 255, 1); cursor: pointer"
            @click="handleDetail(row, 2)"
            >{{ row.disposeNum }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="完成率" align="center">
        <template slot-scope="{ row }">
          <div class="tablecolumn">
            {{ row.finishRate ? row.finishRate * 100 + "%" : "" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="评价数" align="center" prop="appraiseNum">
        <template slot-scope="{ row }">
          <span
            style="color: rgba(25, 144, 255, 1); cursor: pointer"
            @click="handleDetail(row, 3)"
            >{{ row.appraiseNum }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="好评率" align="center">
        <template slot-scope="{ row }">
          <div class="tablecolumn">
            {{ row.highPraiseRate ? row.highPraiseRate * 100 + "%" : "" }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "causallyPushTable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
    console.log("asdasd");
  },
  methods: {
    // 详情
    handleDetail(row, type) {
      console.log(row, "row");
      this.$router.push({
        path: "/causallyPush/detail",
        query: {
          type: type,
          time: row.date,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.s1 {
  color: rgba(78, 162, 124, 1);
}

.s2 {
  color: rgba(254, 96, 96, 1);
}

.tablecolumn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 5px;

  img {
    width: 30px;
    height: 35px;
    // margin-left: 10px;
  }
}

.table {
  border: 1px solid #ccc;
  width: 100%;
}

::v-deep {
  .el-table th.el-table__cell {
    background: #f5f7fa !important;
  }
  .green {
    background: #84d4be !important;
    color: #000 !important;
  }
  .red {
    background: #fdb0b0 !important;
    color: #000 !important;
  }
  .yellow {
    background: #ffdd8f !important;
    color: #000 !important;
  }
  .lastColor {
    background: rgb(171, 228, 217) !important;
    /* 如果需要，调整底部行的背景颜色 */
    color: rgba(51, 51, 51, 1) !important;
  }

  .el-table thead.is-group th.el-table__cell {
    background: rgba(231, 240, 240, 1);
  }

  // thead {
  //   tr:nth-child(2) {
  //     th {
  //       background: rgb(171, 228, 217) !important;
  //     }
  //   }
  // }
  .cell {
    // height: 22px;
    // line-height: 22px;
    padding: 10px 0;
  }
  th {
    .cell {
      padding: 20px 0;
    }
  }
  .el-table__cell {
    border-color: #ccc !important;
    color: #000;
    font-size: 26px !important;
    // background: rgba(231, 240, 240, 1);
    padding: 0;
  }

  .el-table__body {
    width: 100% !important;
    // 选中最后一行tr
    tr:last-child {
      td {
        // background: rgb(171, 228, 217) !important;
      }
    }
  }

  .el-table th.gutter {
    display: none;
    width: 0;
  }

  .el-table colgroup col[name="gutter"] {
    display: none;
    width: 0;
  }

  .el-table--scrollable-y .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  // tbody {
  //   tr:last-child {
  //     position: sticky;
  //     bottom: 0;
  //     z-index: 1; /* 保证底部行位于表格内容之上 */
  //     td {
  //       background: rgb(
  //         171,
  //         228,
  //         217
  //       ) !important; /* 如果需要，调整底部行的背景颜色 */
  //       color: rgba(51, 51, 51, 1) !important;
  //     }
  //   }
  // }
}
</style>
